<template>
    <div class="coordinacion-convenios">
        <div style="background: #E0F7FA; padding: 5px 10px; border-bottom: 1px solid #00BCD4">
            <el-row :gutter="20">
                <el-col :sm="12" :offset="0">
                    <h4 style="margin:10px 20px">COORDINACIÓN DE RECETAS / CONVENIOS</h4>
                </el-col>

            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CoordinacionConvenios',
    data() {
        return {
            convenios: [
                { id: 1, nombre: 'Convenio A', fechaInicio: '2024-01-01', fechaFin: '2024-12-31', estado: 'Activo' },
                { id: 2, nombre: 'Convenio B', fechaInicio: '2024-02-01', fechaFin: '2024-11-30', estado: 'Pendiente' },
                { id: 3, nombre: 'Convenio C', fechaInicio: '2024-03-01', fechaFin: '2024-10-31', estado: 'Vencido' }
            ]
        }
    },
    methods: {
        editarConvenio(convenio) {
            console.log('Editar convenio:', convenio)
        },
        eliminarConvenio(convenio) {
            console.log('Eliminar convenio:', convenio)
        }
    }
}
</script>

<style lang="scss" scoped>
.coordinacion-convenios {
    padding: 0px;
    
    h2 {
        color: #409EFF;
        margin-bottom: 30px;
    }
    
    .convenios-content {
        .el-card {
            margin-bottom: 20px;
        }
    }
}
</style> 